import { render } from "./news.vue?vue&type=template&id=519c547f&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=519c547f&lang=css"
import "./news.vue?vue&type=style&index=1&id=519c547f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519c547f"]])

export default __exports__